// c-sticky-subnav.js
document.addEventListener('DOMContentLoaded', () => {
  const headerLogo = document.querySelector('.header__heading-link');
  const stickySubnav = document.querySelector('.sticky-subnav');
  if (!headerLogo || !stickySubnav) return;

  // ロゴが縮小（= c-header-logo が外れた）状態かどうかで出し分け
  const updateSubnav = () => {
    const collapsed = !headerLogo.classList.contains('c-header-logo');
    stickySubnav.classList.toggle('is-visible', collapsed);
  };

  // 初期反映
  updateSubnav();

  // c-header.js が class を切り替えるので、それを監視
  const mo = new MutationObserver(() => updateSubnav());
  mo.observe(headerLogo, { attributes: true, attributeFilter: ['class'] });

  // 念のためスクロール/リサイズ時にも同期（低コスト）
  let rafId = null;
  const syncOnScroll = () => {
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      updateSubnav();
      rafId = null;
    });
  };
  window.addEventListener('scroll', syncOnScroll, { passive: true });
  window.addEventListener('resize', syncOnScroll);
});